export default __webpack_public_path__ + "static/media/CarImages.SeltosSmall.ed56e976.jpg";